// extracted by mini-css-extract-plugin
module.exports = {"actionCta":"CommAction_actionCta__2_E7M"};